import styled from "styled-components";
import Select from "react-select";
import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  CancelButton,
  ColSpan1,
  ColSpan2,
  ColSpan3,
  ColTitle,
  DeleteButton,
  Input,
  InputLabel,
  inputStyle,
  RelativeDiv,
  RowSpan,
  Span4,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../assets/GlobalStyles";
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useAtom, useAtomValue} from "jotai";
import {accountProfile, refundRequestData} from "./entity";
import {
  accountFileUpload,
  accountInsertInvoiceProfile,
  accountUserProfile,
} from "../../services/account/AccountAdminAxios";
import {removeStr} from "../../common/StringUtils";
import {toast, ToastContainer} from "react-toastify";
import ImageUploading from "react-images-uploading";
import {tokenResultAtom} from "../login/entity";
import {AdminInfo, UserInfo} from "../layout";
import {selUserInfo} from "../../services/platform/ManageUserAxios";
import {useNavigate} from "react-router-dom";

function AccountProfile() {
  const navigate = useNavigate();
  const [tokenResultInfo] = useAtom(tokenResultAtom)
  const [accountProfileState,] = useAtom(accountProfile)
  const [invoiceProfileState, setInvoiceProfileState] = useState(accountProfile)
  const [isExistingProfile, setIsExistingProfile] = useState(Boolean(accountProfileState?.username))
  const [adminInfoState] = useAtom(AdminInfo)
  const userInfoState = useAtomValue(UserInfo)
  const {register, control, handleSubmit, setValue, setError, clearErrors, reset ,formState: {errors}} = useForm({
    mode: "onSubmit",
    defaultValues: accountProfileState
  })

  useEffect(() => {
    if (adminInfoState.convertedUser === '') {
      setInvoiceProfileState(null);
      return;
    }

    accountUserProfile(adminInfoState.convertedUser).then(response => {
      if (response !== null) {
        setIsExistingProfile(true);
        const profile = {
          ...response,
          username: adminInfoState.convertedUser,
        };

        setInvoiceProfileState(profile);
        reset(profile);
        return;
      }

      selUserInfo(userInfoState?.id).then(userResponse => {
        setIsExistingProfile(false);
        const profile = {
          username: adminInfoState.convertedUser,
          mediaType: userResponse?.mediaType,
          grossCalculate: 0,
        };

        setInvoiceProfileState(prev => ({
          ...prev,
          ...profile,
        }));

        reset(profile);
      });
    });
  }, [
    adminInfoState.convertedUser,
    reset,
    userInfoState?.id,
  ]);

  /**
   * 담당자명 입력
   * @param event
   */
  const handleManagerName = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      managerName: event.target.value
    })
  }
  /**
   * 담당자 연락처 입력
   * @param event
   */
  const handleManagerPhone = (event) => {
    let num = event.target.value
    setInvoiceProfileState({
      ...invoiceProfileState,
      managerPhone: num
    })
  }
  /**
   * 담당자 이메일 입력
   * @param event
   */
  const handleManagerEmail = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      managerEmail: event.target.value
    })
  }
  const handleBusinessName = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      businessName: event.target.value,
    })
  }
  const handleBusinessNumber = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      businessNumber: event.target.value,
    })
  }
  const handleBusinessCeoName = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      ceoName: event.target.value,
    })
  }
  const handleBusiness = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      business: event.target.value
    })
  }

  const handleBusinessType = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      businessType: event.target.value
    })
  }

  const handleAddress = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      address: event.target.value
    })
  }

  const handleBankNumber = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      bankAccountNumber: event.target.value
    })
  }

  const handleAccountHolder = (event) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      accountHolder: event.target.value
    })
  }

  const handleBusinessLicense = async (pictureFiles) => {
    if(pictureFiles.length !== 0){
      const data = new FormData()
      const imagesLastIndex = pictureFiles.length-1;
      data.append('file', pictureFiles[imagesLastIndex].file, pictureFiles[imagesLastIndex].file.name)
      await accountFileUpload(adminInfoState.convertedUser, data,'LICENCE').then(response => {
        const { uploadedFile, path } = response;
        console.log(response);
        if(uploadedFile) {
          toast.success('업로드에 성공 했습니다.')
          setInvoiceProfileState({
            ...invoiceProfileState,
            businessLicenseCopy: path,
            businessLicenseCopyName: pictureFiles[imagesLastIndex].file.name
          })
          setValue('businessLicenseCopyName', pictureFiles[imagesLastIndex].file.name)
          setError('businessLicenseCopyName', '')
        } else {
          toast.warning('업로드에 실패 했습니다.')
        }
      })
    }
  }

  const handlePassbook = (pictureFiles) => {
    if(pictureFiles.length !== 0){
      const data = new FormData()
      const imagesLastIndex = pictureFiles.length -1;
      data.append('file', pictureFiles[imagesLastIndex].file, pictureFiles[imagesLastIndex].file.name)
      accountFileUpload(adminInfoState.convertedUser, data,'PASSBOOK').then(response => {
        const { uploadedFile, path } = response;
        if(uploadedFile) {
          toast.success('업로드에 성공 했습니다.')
          setInvoiceProfileState({
            ...invoiceProfileState,
            passbookCopy: path,
            passbookCopyName: pictureFiles[imagesLastIndex].file.name,
          })
          setValue('passbookCopyName', pictureFiles[imagesLastIndex].file.name)
          setError('passbookCopyName', '')
        } else {
          toast.warning('업로드에 실패 했습니다.')
        }
      })
    }
  }

  const onImageError = (errors) => {
    if (errors.maxFileSize) {
      setError('businessLicenseCopyName',{ type: 'maxFileSize', message: '저장 가능한 이미지 사이즈는 1MB 입니다.'})
    } else if (errors.maxNumber) {
      setError('businessLicenseCopyName',{ type: 'maxNumber', message: '이미지는 1개만 등록 가능합니다.'})
    } else if (errors.acceptType) {
      setError('businessLicenseCopyName',{ type: 'acceptType', message: '"jpg", "gif", "png"의 형식만 등록 가능합니다.'})
    }
  }

  const imageDel = (resourceType) => {
    if(resourceType !== 'LICENCE') {
      setInvoiceProfileState({
        ...invoiceProfileState,
        passbookCopy: '',
        passbookCopyName: '',
      })
      setValue('passbookCopyName', '')
    } else {
      setInvoiceProfileState({
        ...invoiceProfileState,
        businessLicenseCopy: '',
        businessLicenseCopyName: '',
      })
      setValue('businessLicenseCopyName', '')
    }
  }

  const taxType = (value) => {
    setInvoiceProfileState({
      ...invoiceProfileState,
      taxYn: value
    })
  }

  const handleGrossCalculate = (value) => {
    let num = removeStr(value)
    let grossCalculate = value !== '' ? parseInt(num) : 0
    if (grossCalculate <= 100) {
      setInvoiceProfileState({
        ...invoiceProfileState,
        grossCalculate: grossCalculate
      })
      clearErrors('grossCalculate')
    } else {
      setError('grossCalculate', { type: 'required', message: '100이하로 입력해주세요.'})
    }
  }
  const handleChangeIsBank = (event) => { // 은행 선택
    setInvoiceProfileState({
      ...invoiceProfileState,
      bankType: event.value
    })
  }
  const onSubmit = () => {
    accountInsertInvoiceProfile(invoiceProfileState).then(response => {
      if(response){
        window.alert(isExistingProfile ? '정산 프로필 정보가 수정되었습니다.' : '정산 프로필 정보가 등록되었습니다.');
        navigate('/board/account')
      } else {
        toast.warning(isExistingProfile ? '정산 프로필 정보 수정에 실패했습니다.' : '정산 프로필 정보 등록에 실패했습니다.',{autoClose:100, delay:0});
      }
    })
  }

  const onError = (error) => toast.warning(error)
  return (
    <>
      {
        tokenResultInfo.id !== null && invoiceProfileState !== null &&
        <ProfileForm onSubmit={handleSubmit(onSubmit, onError)}>
          <ProfilePageHeader><div><strong>정산 프로필 관리</strong><span>정산과 세금계산서 발행에 필요한 사업자 및 지급 정보를 관리합니다.</span></div><ProfileRequired><i/>필수 정보를 정확하게 입력해 주세요.</ProfileRequired></ProfilePageHeader>
          <SelectedMediaBanner><SelectedMediaIcon><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20V7l8-4 8 4v13M8 10h2m4 0h2m-8 4h2m4 0h2M3 20h18"/></svg></SelectedMediaIcon><SelectedMediaDetails><MediaDatum><span>매체명</span><strong>{adminInfoState.name || invoiceProfileState.siteName || "매체명 미등록"}</strong></MediaDatum><MediaDatum><span>아이디</span><strong>{adminInfoState.convertedUser || invoiceProfileState.username || "-"}</strong></MediaDatum></SelectedMediaDetails><SelectedMediaType>{invoiceProfileState.mediaType === 'AGENCY' ? '대행사' : '매체사'}</SelectedMediaType></SelectedMediaBanner>
          <ProfileGrid>
          <Board>
            <ProfileCardHeader><div><strong>사업자 정보</strong><span>사업자 등록 정보와 정산 담당자 정보를 입력합니다.</span></div><SectionBadge>BUSINESS</SectionBadge></ProfileCardHeader>
            <BoardSearchDetail>
              <RowSpan>
                <ColSpan3>
                  <ColTitle><Span4>매체구분</Span4></ColTitle>
                  <div>{(invoiceProfileState.mediaType !== 'AGENCY') ? '매체사' :'대행사'}</div>
                </ColSpan3>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>담당자<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'담당자 명을 입력해주세요'}
                      {...register("managerName", {
                        required: "담당자 명을 입력해주세요",
                        onChange:(e) => handleManagerName(e)
                      })}
                      value={invoiceProfileState.managerName || ""}
                    />
                    {errors.managerName && <ValidationScript>{errors.managerName?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>이메일<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'이메일을 입력해주세요.'}
                      {...register("managerEmail", {
                        required: "담당자 이메일을 입력해주세요.",
                        pattern: {
                          value: /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i,
                          message: "이메일 형식을 확인해주세요"
                        },
                        onChange: (e) => handleManagerEmail(e)
                      })}
                      value={invoiceProfileState.managerEmail || ""}

                    />
                    {errors.managerEmail && <ValidationScript>{errors.managerEmail?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>연락처<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'연락처를 입력해주세요.'}
                      {...register("managerPhone", {
                        required: "담당자 연락처를 입력해주세요.",
                        pattern: {
                          // value: /0([1-9][0-9]?){1,2}[.-]?([0-9]{3,4})[.-]?([0-9]{4})/g,
                          value: /^[0-9-]+$/g,
                          message: "연락처 정보를 확인해주세요"
                        },
                        onChange : (e) => handleManagerPhone(e)
                      })}
                      value={invoiceProfileState.managerPhone || ""}
                      maxLength={11}
                    />
                    {errors.managerPhone && <ValidationScript>{errors.managerPhone?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>회사명<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'ex) 회사명_년월일'}
                      {...register("businessName", {
                        required: "회사명을 입력 해주세요",
                        onChange:(e) => handleBusinessName(e)
                      })}
                      value={invoiceProfileState.businessName || ""}
                    />
                    {errors.businessName && <ValidationScript>{errors.businessName?.message}</ValidationScript>}

                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan style={{justifyContent: 'flex-start'}}>
                <ColSpan2>
                  <ColTitle><Span4>사업자 등록 번호<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'사업자 등록 번호'}
                      {...register("businessNumber", {
                        required: "사업자 등록 번호를 입력 해주세요",
                        onChange:(e) => handleBusinessNumber(e)
                      })}
                      value={invoiceProfileState.businessNumber || ""}
                    />
                    {errors.businessNumber && <ValidationScript>{errors.businessNumber?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>업태<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'업태'}
                      {...register("business", {
                        required: "업태를 입력해주세요",
                        onChange:(e) => handleBusiness(e)
                      })}
                      value={invoiceProfileState.business || ""}
                    />
                    {errors.business && <ValidationScript>{errors.business?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>종목<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'종목'}
                      {...register("businessType", {
                        required: "종목을 입력해주세요",
                        onChange:(e) => handleBusinessType(e)
                      })}
                      value={invoiceProfileState.businessType || ""}
                    />
                    {errors.businessType && <ValidationScript>{errors.businessType?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>대표자 성명<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'대표자 성명'}
                      {...register("ceoName", {
                        required: "회사명을 입력 해주세요",
                        onChange:(e) => handleBusinessCeoName(e)
                      })}
                      value={invoiceProfileState.ceoName || ""}
                    />
                    {errors.ceoName && <ValidationScript>{errors.ceoName?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>사업장 주소<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'사업장 주소'}
                      {...register("address", {
                        required: "주소를 입력해주세요",
                        onChange:(e) => handleAddress(e)
                      })}
                      value={invoiceProfileState.address || ""}
                    />
                    {errors.address && <ValidationScript>{errors.address?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan style={{justifyContent: 'flex-start'}}>
                <ColSpan2>
                  <ColTitle><Span4>사업자 등록증<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      style={{paddingRight: 35}}
                      type={'text'}
                      placeholder={'사업자 등록증'}
                      {...register("businessLicenseCopyName", {
                        required: "사업자 등록증을 등록해주세요",
                      })}
                      value={invoiceProfileState.businessLicenseCopyName || ""}
                      readOnly={true}
                    />
                    {errors.businessLicenseCopyName && <ValidationScript>{errors.businessLicenseCopyName?.message}</ValidationScript>}
                    <DeleteButton type={'button'} onClick={()=> imageDel('LICENCE')} />
                  </RelativeDiv>
                </ColSpan2>
                <ColSpan1>
                    <ImageUploading
                      acceptType={["jpg", "gif", "png"]}
                      onChange={handleBusinessLicense}
                      maxFileSize={1048576}
                      maxNumber={1}
                      onError={(e)=> onImageError(e)}
                    >
                      {({onImageUpload}) => (
                        <DuplicateButton
                          type={'button'}
                          onClick={onImageUpload}
                        >파일 첨부</DuplicateButton>
                      )}
                    </ImageUploading>
                </ColSpan1>
              </RowSpan>
            </BoardSearchDetail>
          </Board>
          <Board>
            <ProfileCardHeader><div><strong>정산 정보</strong><span>정산금 지급에 사용할 계좌와 과세 정보를 입력합니다.</span></div><SectionBadge>PAYMENT</SectionBadge></ProfileCardHeader>
            <BoardSearchDetail>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>은행 선택<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <ColSpan2>
                      <Controller
                        name="bankType"
                        control={control}
                        rules={{
                          required: {
                            value: invoiceProfileState?.bankType === undefined,
                            message: "은행을 선택해주세요."
                          }
                        }}
                        render={({ field }) =>(
                          <Select options={refundRequestData.bankType !== null && refundRequestData.bankType}
                                  placeholder={'은행 선택'}
                                  {...field}
                                  value={invoiceProfileState?.bankType !== undefined ? refundRequestData.bankType.find(type => type.value === invoiceProfileState?.bankType) : ''}
                                  onChange={(e)=>handleChangeIsBank(e)}
                                  styles={inputStyle}
                          />
                        )}
                      />
                    </ColSpan2>
                    {errors.bankType && <ValidationScript>{errors.bankType?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan style={{justifyContent: 'flex-start'}}>
                <ColSpan2>
                  <ColTitle><Span4>계좌 번호<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'계좌 번호'}
                      {...register("bankAccountNumber", {
                        required: "계좌 번호를 입력해주세요",
                        onChange:(e) => handleBankNumber(e)
                      })}
                      value={invoiceProfileState.bankAccountNumber || ""}
                    />
                    {errors.bankAccountNumber && <ValidationScript>{errors.bankAccountNumber?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>예금주<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      type={'text'}
                      placeholder={'예금주'}
                      {...register("accountHolder", {
                        required: "예금주를 입력해주세요",
                        onChange:(e) => handleAccountHolder(e)
                      })}
                      value={invoiceProfileState.accountHolder || ""}
                    />
                    {errors.accountHolder && <ValidationScript>{errors.accountHolder?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan style={{justifyContent: 'flex-start'}}>
                <ColSpan2>
                  <ColTitle><Span4>통장 사본<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <Input
                      style={{paddingRight: 35}}
                      type={'text'}
                      placeholder={'통장 사본'}
                      {...register("passbookCopyName", {
                        required: "통장 사본을 등록해주세요",
                      })}
                      value={invoiceProfileState.passbookCopyName || ""}
                      readOnly={true}
                    />
                    {errors.passbookCopyName && <ValidationScript>{errors.passbookCopyName?.message}</ValidationScript>}
                    <DeleteButton type={'button'} onClick={()=> imageDel('PASSBOOK')}/>
                  </RelativeDiv>
                </ColSpan2>
                <ColSpan1>
                  <ImageUploading
                    acceptType={["jpg", "gif", "png"]}
                    onChange={handlePassbook}
                    maxFileSize={1048576}
                    maxNumber={1}
                    onError={(e)=> onImageError(e)}
                  >
                    {({onImageUpload}) => (
                      <DuplicateButton
                        type={'button'}
                        onClick={onImageUpload}
                      >파일 첨부</DuplicateButton>
                    )}
                  </ImageUploading>
                </ColSpan1>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>과세 여부</Span4></ColTitle>
                  <RelativeDiv>
                    <ColSpan2>
                      <input type={'radio'} id={'taxation'} name={'taxSelect'} checked={invoiceProfileState.taxYn === 'Y'} onChange={() => taxType('Y')}/>
                      <label htmlFor={'taxation'}>과세</label>
                      <input type={'radio'} id={'taxFree'} name={'taxSelect'} checked={invoiceProfileState.taxYn === 'N'} onChange={() => taxType('N')}/>
                      <label htmlFor={'taxFree'}>면세</label>
                    </ColSpan2>
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
              <RowSpan>
                <ColSpan2>
                  <ColTitle><Span4>그로스 정산<RequiredMark>*</RequiredMark></Span4></ColTitle>
                  <RelativeDiv>
                    <ColSpan2>
                      <InputLabel label={'%'}>
                        <Input type={'text'}
                               maxLength={3}
                               placeholder={'그로스 정산을 입력해 주세요.'}
                               {...register("grossCalculate", {
                                 required: "그로스 정산을 입력해 주세요.",
                                 pattern:{
                                   value: /^[0-9,]+$/,
                                   message: "숫자만 입력 가능합니다."
                                 },
                               })}
                               onChange={(e) => handleGrossCalculate(e.target.value)}
                               value={invoiceProfileState.grossCalculate !== undefined ? invoiceProfileState.grossCalculate : ''}
                        />
                      </InputLabel>
                    </ColSpan2>
                    {errors.grossCalculate && <ValidationScript>{errors.grossCalculate?.message}</ValidationScript>}
                  </RelativeDiv>
                </ColSpan2>
              </RowSpan>
            </BoardSearchDetail>
          </Board>
          </ProfileGrid>
          <SubmitContainer><ActionGuide><strong>{isExistingProfile ? '정산 프로필 수정' : '정산 프로필 등록'}</strong><span>{isExistingProfile ? '변경한 정보를 확인한 뒤 수정 버튼을 눌러 저장해 주세요.' : '입력한 정보를 확인한 뒤 등록 버튼을 눌러 저장해 주세요.'}</span></ActionGuide><ActionButtons><CancelButton type="button" onClick={()=>navigate('/board/account')}>{isExistingProfile ? '취소' : '목록'}</CancelButton><SubmitButton type={"submit"}>{isExistingProfile ? '수정' : '등록'}</SubmitButton></ActionButtons></SubmitContainer>
        </ProfileForm>
      }
      <ToastContainer position="top-center"
                      autoClose={1500}
                      hideProgressBar
                      newestOnTop={false}
                      closeOnClick
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                      limit={1}
                      style={{zIndex: 9999999}}/>
    </>
  )
}

export default AccountProfile

const DuplicateButton = styled.button`
  width: 110px;
  height: 42px;
  border: 1px solid #93bce8;
  border-radius: 7px;
  background: #f4f8fd;
  color: var(--color-primary-strong);
  font-size: var(--font-size-10);
  font-weight: 750;

  &:hover { border-color: var(--color-primary-strong); background: #eaf3ff; }
`

const ProfileForm = styled.form`
  padding: 0 0 24px;

  ${Board} {
    min-width: 0;
    margin: 0;
    overflow: hidden;
    border: 1px solid var(--color-border-strong);
    border-radius: 12px;
    background: var(--color-surface);
    box-shadow: 0 6px 20px rgba(31,41,55,.05);
  }

  ${BoardSearchDetail} { padding: 8px 20px 18px; }
  ${BoardHeader} { display: none; }

  ${RowSpan} {
    min-height: 60px;
    margin: 0;
    padding: 9px 0;
    border-bottom: 1px solid var(--color-divider);
    background: var(--color-surface);
  }

  ${RowSpan}:last-child { border-bottom: 0; }
  ${ColSpan2}, ${ColSpan3} { width: 100%; min-width: 0; }
  ${ColSpan1} { flex: 0 0 110px; margin-left: 8px; }
  ${ColTitle} { min-width: 132px; padding: 0 12px 0 4px; color: #444; font-size: var(--font-size-11); font-weight: 650; }
  ${RelativeDiv} { min-width: 0; width: 100%; }

  ${Input} {
    width: 100%;
    height: 42px;
    padding: 0 12px;
    border: 1px solid #d9e1e8;
    border-radius: 7px;
    background: var(--color-surface);
    color: var(--color-text);
    font-size: var(--font-size-10);
    outline: none;
    transition: border-color .15s ease, box-shadow .15s ease;
  }

  ${Input}:focus { border-color: var(--color-primary); box-shadow: 0 0 0 3px rgba(59,130,246,.1); }
  ${Input}[readonly] { background: #f8fafc; color: #66717d; }
  ${ValidationScript} { margin-top: 5px; color: var(--color-danger-strong); font-size: var(--font-size-9)!important; }

  [class*="-control"] { min-height: 42px!important; border-color: #d9e1e8!important; border-radius: 7px!important; box-shadow: none!important; font-size: var(--font-size-10); }
  [class*="-control"]:hover { border-color: var(--color-primary-focus)!important; }

  input[type="radio"] { width: 16px; height: 16px; margin: 0 7px 0 0; accent-color: var(--color-primary-strong); }
  input[type="radio"] + label { margin-right: 24px; color: #4b5662; font-size: var(--font-size-10); font-weight: 650; }

  ${DeleteButton} { right: 11px; }

  ${SubmitContainer} {
    position: sticky;
    bottom: 0;
    z-index: 5;
    display: flex!important;
    align-items: center!important;
    justify-content: space-between!important;
    gap: 16px;
    margin: 18px 0 0!important;
    padding: 16px 20px!important;
    border: 1px solid var(--color-primary-border)!important;
    border-left: 4px solid var(--color-primary)!important;
    border-radius: 10px!important;
    background: #f7faff!important;
  }

  ${CancelButton}, ${SubmitButton} {
    width: auto!important;
    min-width: 92px!important;
    height: 40px!important;
    margin: 0!important;
    padding: 0 18px!important;
    border-radius: 7px!important;
    font-size: var(--font-size-11)!important;
    font-weight: 700!important;
  }

  ${SubmitButton} { border-color: var(--color-primary-strong)!important; background: var(--color-primary-strong)!important; color: var(--color-surface)!important; }

  @media(max-width: 720px) {
    ${BoardSearchDetail} { padding: 6px 14px 14px; }
    ${RowSpan} { align-items: stretch; flex-direction: column; gap: 7px; }
    ${ColTitle} { min-width: 0; padding: 0; }
    ${ColSpan1} { margin-left: 0; }
    ${DuplicateButton} { width: 100%; }
    ${SubmitContainer} { align-items: stretch!important; flex-direction: column; }
  }
`;

const ProfilePageHeader = styled.div`display:flex;align-items:flex-end;justify-content:space-between;gap:20px;margin-bottom:18px;strong,span{display:block;}strong{color:#20242b;font-size: var(--font-size-22);font-weight:750;letter-spacing:-.025em;}span{margin-top:7px;color:#89929d;font-size: var(--font-size-10);}@media(max-width:640px){align-items:flex-start;flex-direction:column;}`;
const ProfileRequired = styled.div`display:flex;align-items:center;gap:7px;color:#77828d;font-size: var(--font-size-9);i{width:7px;height:7px;border-radius:50%;background:var(--color-primary-strong);box-shadow:0 0 0 3px rgba(37,99,235,.1);}`;
const SelectedMediaBanner = styled.div`display:flex;min-height:76px;align-items:center;gap:14px;margin-bottom:18px;padding:13px 16px;border:1px solid var(--color-primary-border);border-left:4px solid var(--color-primary-strong);border-radius:10px;background:linear-gradient(135deg,var(--color-surface-muted),#eef6ff);box-shadow:0 4px 14px rgba(37,99,235,.06);@media(max-width:700px){align-items:flex-start;flex-wrap:wrap;}`;
const SelectedMediaIcon = styled.div`display:flex;width:38px;height:38px;flex:0 0 38px;align-items:center;justify-content:center;border-radius:9px;background:var(--color-primary-strong);color:var(--color-surface);box-shadow:0 5px 12px rgba(37,99,235,.2);svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round;}`;
const SelectedMediaDetails = styled.div`display:grid;min-width:0;flex:1;grid-template-columns:repeat(2,minmax(0,1fr));@media(max-width:700px){order:3;width:100%;flex-basis:100%;grid-template-columns:1fr;gap:8px;}`;
const MediaDatum = styled.div`min-width:0;padding:0 18px;border-right:1px solid #d7e5f4;&:first-child{padding-left:0;}&:last-child{border-right:0;}span,strong{display:block;}span{color:#68809a;font-size: var(--font-size-9);font-weight:650;}strong{margin-top:5px;overflow:hidden;color:#26394d;font-size: var(--font-size-12);font-weight:800;text-overflow:ellipsis;white-space:nowrap;}@media(max-width:700px){padding:0;border-right:0;}`;
const SelectedMediaType = styled.b`display:inline-flex;height:26px;flex:0 0 auto;align-items:center;padding:0 9px;border:1px solid #a9caee;border-radius:999px;background:var(--color-surface);color:var(--color-primary-strong);font-size: var(--font-size-9);font-weight:750;`;
const ProfileGrid = styled.div`display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px;align-items:start;@media(max-width:1050px){grid-template-columns:minmax(0,1fr);}`;
const ProfileCardHeader = styled.header`display:flex;min-height:70px;align-items:center;justify-content:space-between;gap:16px;padding:15px 20px;border-bottom:1px solid #e5e9ee;background:linear-gradient(135deg,var(--color-surface),#f7faff);strong,span{display:block;}strong{position:relative;padding-left:11px;color:#252b33;font-size: var(--font-size-15);font-weight:750;}strong:before{position:absolute;top:1px;bottom:1px;left:0;width:3px;border-radius:3px;background:var(--color-primary-strong);content:"";}span{margin-top:5px;color:var(--color-text-muted);font-size: var(--font-size-9);}`;
const SectionBadge = styled.b`padding:6px 8px;border:1px solid #cfe0f4;border-radius:999px;background:var(--color-primary-soft);color:var(--color-primary-strong);font-size: var(--font-size-8);letter-spacing:.04em;`;
const RequiredMark = styled.em`margin-left:3px;color:var(--color-danger);font-size: var(--font-size-11);font-style:normal;font-weight:800;`;
const ActionGuide=styled.div`min-width:0;text-align:left;strong,span{display:block;}strong{color:#2f3438;font-size: var(--font-size-12);font-weight:800;}span{margin-top:4px;color:#7f878e;font-size: var(--font-size-9);line-height:1.45;}`;
const ActionButtons=styled.div`display:flex;flex:0 0 auto;align-items:center;gap:8px;@media(max-width:720px){width:100%;button{flex:1;}}`;
